import { config } from '../config'
import { Title } from '../styles'

import { Member } from './Member'
import {
  Members,
  Wrapper,
  ImageWrapper,
  TeamHexagon,
  TeamTwoHexagon,
  Content,
  TeamImage,
} from './styles'

const {
  team: { teamImage, teamMembers, title },
} = config

export function Team() {
  return (
    <Wrapper>
      <Title as="h2">{title}</Title>
      <Content>
        <Members>
          {teamMembers.map(teamMember => (
            <Member key={teamMember.role} {...teamMember} />
          ))}
          <TeamHexagon />
          <TeamTwoHexagon />
        </Members>
        <ImageWrapper>
          <TeamImage {...teamImage} />
        </ImageWrapper>
      </Content>
    </Wrapper>
  )
}
